import React from 'react';
import { Route,} from 'react-router-dom';
import { GuardedComponent } from './GuardedComponent';

export const GuardedRoute = ({component: Component, ...rest}) => {
  return (
    <Route {...rest} render={(props) => (
     <GuardedComponent component={Component} {...props} />
    )} />
  )
};
